'use client';
import { Transformer } from './Transformer/Transformer.js';

var AnalyticsTopic = function(options) {
    var sendEvent = function sendEvent(eventName, payload) {
        bus.emit("event-added", eventName, transformer.reduce(eventName, payload));
    };
    var bus = options.bus, _options_transforms = options.transforms, transforms = _options_transforms === void 0 ? [] : _options_transforms;
    var transformer = Transformer(transforms);
    var analyticsTopic = {
        sendEvent: sendEvent
    };
    return analyticsTopic;
};

export { AnalyticsTopic };
